@if (_active) {
  <kendo-window title="Deactivating Data" (keydown.enter)="$event.preventDefault()"
    (close)="_closeForm()" (stateChange)="_onStateChanges($event)">
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row no_row_margin">
        <div class="col-12" style="margin-top: 10px">
          <button kendoButton class="steps_buttons_class" (click)="_onCancel()">
            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
            <span>Cancel</span>
          </button>
          <button kendoButton class="steps_buttons_class" (click)="_onDelete()" [disabled]="inavlidform">
            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
            <span>save & Close</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="borderedSections" [class.active-step]="currentStep === 1">
            <div class="row">
              <div class="col-12">
                <div class="rtClass">
                  Why do you want to Deactivate {{_batch ? 'these Items' : 'this Item'}}?
                </div>
              </div>
              <div class="col-12 margin-top-10">
                <div class="row">
                  <div class="col-12 col-sm-3 col-md-2">
                    <label for="startdate" class="control-label reportslabel">Note</label>
                  </div>
                  <div class="col-12 col-sm-9 col-md-10">
                    <kendo-combobox #Kendo_Combo_Notes
                      [data]="_notes"
                      [suggest]="true"
                      (valueChange)="_noteSubmited($event)"
                      (focus)="_noteFocusEvent()"
                      (focusout)="_skipNotes()"
                      (open)="_notesComboOpening()"
                      [formControl]="_note"
                      required
                      [textField]="'description'"
                      [valueField]="'id'"
                      class="newFormControlWidth">
                    </kendo-combobox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (!_locationTypePage && _currentUser?.isEnterprise) {
            <div class="borderedSections" [class.active-step]="currentStep === 2">
              <div class="row">
                <div class="col-12">
                  <div class="rtClass">Select Accounts and Sites</div>
                </div>
                <div class="col-12">
                  <!-- [showOnlySelected]="true" -->
                  @if (_showAccountsGrid) {
                    <asap-account-sites-selection
                      [disabled]="true"
                      [selectedAccounts]="_selectedAccounts"
                      [resolver]="_getAccounts">
                    </asap-account-sites-selection>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </form>
  </kendo-window>
}
